import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695ae4cd7683ed00143500cf/one_solar_energy/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695ae4cd7683ed00143500cf/one_solar_energy/src/app/landing-page/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695ae4cd7683ed00143500cf/one_solar_energy/src/components/common/Header.tsx");
